import React from 'react';

const Caption = ({caption}) => (
    <div className={'lazy-image-list__text-panel'}>
        {caption}
    </div>
)

export default Caption;